// base url
if (location.hostname == 'localhost' || location.hostname == 'localhost:8888') {
    var path = '/mamabw/';
} else {
    var path = '/';
}

var import_data = $.ajax({ type: 'GET',   
                        url: path+'data.json',   
                        async: false
                      }).responseText;
var define = JSON.parse(import_data)[0];

var token = $('html').attr('token');
var lang = $('html').attr('lang');

$(document).ready(function() {
   
    var data_table_i18n = { 'fr': 'French', 'en' : 'English', 'nl' : 'Dutch'};

    toastr.options = {
		"closeButton": true,
		"debug": false,
		"newestOnTop": false,
		"progressBar": true,
		"positionClass": "toast-top-center",
		"preventDuplicates": true,
		"onclick": null,
		"showDuration": "300",
		"hideDuration": "1000",
		"timeOut": "2000",
		"extendedTimeOut": "1000",
		"showEasing": "swing",
		"hideEasing": "linear",
		"showMethod": "fadeIn",
		"hideMethod": "fadeOut"
	}

	// init datatable
	if($('body').find('.data-table').length>0) {
		//var language = $('html').attr('lang');
        $('.data-table').DataTable({
            responsive: true,
            fixedHeader: {
                header: false,
                footer: true
            },
            "language": {
                "url": "//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/"+data_table_i18n[lang]+".json"
            },
            "pageLength": 25,
            "aaSorting": []
        });

		$.fn.dataTable.moment = function ( format, locale ) {
		    var types = $.fn.dataTable.ext.type;
		 
		    // Add type detection
		    types.detect.unshift( function ( d ) {
		        return moment( d, format, locale, true ).isValid() ?
		            'moment-'+format :
		            null;
		    } );
		 
		    // Add sorting method - use an integer for the sorting
		    types.order[ 'moment-'+format+'-pre' ] = function ( d ) {
		        return moment( d, format, locale, true ).unix();
		    };
		};

		$.fn.dataTable.moment( 'DD-MM-YYYY' );
	}
	
	// init fancybox
	Fancybox.bind("[data-fancybox]", {
	  // Your custom options
	});


	// slider services
	
	$('.slider-services').slick({
		dots: false,
		infinite: false,
		slidesToShow:3,
		slidesToScroll: 1,
		responsive: [
		{
		  breakpoint: 480,
		  settings: {
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    dots:true
		  }
		}
		]
	});
	$('.slider-temoignage').slick({
		dots: false,
		infinite: false,
		slidesToShow:4,
		slidesToScroll: 1,
		responsive: [
		{
		  breakpoint: 992,
		  settings: {
		    slidesToShow: 3,
		    slidesToScroll: 1,
		    dots:true
		  }
		},
		{
		  breakpoint: 480,
		  settings: {
		    slidesToShow: 2,
		    slidesToScroll: 2,
		    dots:true,
		  }
		}
		]
	});

	// dots images
	if ($('.img-dots').length > 0) {
		// yes
		var el = $('.img-dots');
		var child = el.find('.img-wrapper').addClass('dots');

		if ($('.dots-te').length > 0) {
			var el = $('.dots-te');
			var child = el.find('.img-wrapper').addClass('dots--te');
		}else if($('.dots-ts').length > 0) {
			var el = $('.dots-ts');
			var child = el.find('.img-wrapper').addClass('dots--ts');
		}else if($('.dots-be').length > 0) {
			var el = $('.dots-be');
			var child = el.find('.img-wrapper').addClass('dots--be');
		}else if($('.dots-bs').length > 0) {
			var el = $('.dots-bs');
			var child = el.find('.img-wrapper').addClass('dots--bs');
		}
	}
	

		

	// init datepicker
	$('.datepicker').datepicker({
	    format: "dd-mm-yyyy",
	    weekStart: 1,
	    daysOfWeekDisabled: "0,6",
    	startDate: '0d'
	});

	// init flash
	if($('#modal-flash').length > 0) {
		var flash = $('#modal-flash').data('flash');

		if(localStorage.getItem('flash') === null || localStorage.getItem('flash') != flash) {			
			$('#modal-flash').modal('show');
			localStorage.clear();
		}

		$(document).on('click', '#modal-flash .btn-close', function() {
			localStorage.setItem('flash', flash);
		});

	}

	function recaptcha()
	{
		 grecaptcha.ready(function() {
			grecaptcha.execute(define.keys.GOOGLE_RECAPTCHA_KEY, {action: 'send_form'})
			.then(function(token) {
				var recaptchaResponse = document.getElementById('g-recaptcha-response');
            	recaptchaResponse.value = token;
				
			})
		});
	}

    if($('#g-recaptcha-response').length > 0) {
    	recaptcha();
    	
		var intervalID = setInterval(recaptcha, 110*1000);
    }

	// personnalise les datas à transmettre en dehors d'un serializeArray() dans la fonction xhr_send()
	function xhr_data(file, data) {
		switch(file) {
			case 'formation/search-training':
				var filter = [];
				var cat = [];
				var search = $('#search-training').val();
				var page = $('#paginations .page-item.active').attr('id');
				if (page === undefined) {
					page = 1;
				}

				$('input[data-search-cat]:checked').each(function(i) {
		            filter.push($(this).val());
		            cat.push($(this).data('search-cat'));
		    	});

		    	var range = '1;Cycle';
		    	var duree = '1;Cycle';

		    	data[data.length] = { name: 'filter[]', value: filter };
		    	data[data.length] = { name: 'cat[]', value: cat };
		    	data[data.length] = { name: 'search', value: search };
		    	data[data.length] = { name: 'page', value: page };
		    	data[data.length] = { name: 'range', value: range };
		    	data[data.length] = { name: 'duree', value: duree };
		    	break;
		    default:
		    	return true;
	    }
	}
	
	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response) {
		switch(callback) {
			case  'formation/subscription':
				toastr.success(response.msg);
				$('#modal-subscription').modal('hide');
				$('#modal-subscription').find('input:not([type=hidden])').val('');
				$('#modal-subscription').find('input[type=checkbox]').prop('checked', false);
		    	break;
			case  'formation/cll-subscription':
				toastr.success(response.msg);
				$('#modal-cll-subscription').modal('hide');
				$('#modal-cll-subscription').find('input:not([type=hidden])').val('');
				$('#modal-cll-subscription').find('input[type=checkbox]').prop('checked', false);
		    	break;
			case  'formation/mdlc-subscription':
				toastr.success(response.msg);
				$('#modal-mdlc-subscription').modal('hide');
				$('#modal-mdlc-subscription').find('input:not([type=hidden])').val('');
				$('#modal-mdlc-subscription').find('input[type=checkbox]').prop('checked', false);
		    	break;
	    	case  'contact/contact':
				toastr.success(response.msg);
				$('#form-contact').load(path+'Connections/request/xhr/contact/contact-success.php');
				
		    	break;
		    default:
		    	return true;
		}
	}

	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this) {
		var file = $this.data('xhr');
		if($this.data('type') !== undefined) {
			var type = $this.data('type');
		}
		else {
			var type = null;
		}
		var form = '#'+$this.closest('form').attr('id');

		if(type == 'delete') {
			var id = $this.closest('[data-id]').data('id');

			if(confirm('Voulez-vous supprimer cette ligne ?')) {
				$.post(path+'administration/request/xhr/'+file+'.php', { id: id, token: token }, function(response, statusText, jqXHR) {
					if(response.action == 'success') {

						if(response.callback === true) {
							xhr_success(file, response);
						}
						else {
							if(response.msg != null) {
								toastr.success(response.msg);
							}
							$this.closest('[data-id]').remove()					
						}

						if(response.url != null) {
							location.href = response.url;
						}
					}
					else if(response.action == 'empty') {
						if(response.msg != null) {
							toastr.warning(response.msg);
						}
					}
					else if(response.action == 'recaptcha') {
						if(response.msg != null) {
							toastr.warning(response.msg);
						}
						recaptcha();
					}
					else if(response.action == 'token') {
						location.reload();
					}   
					else {
						if(response.msg != null) {
							toastr.error(response.msg);
						}
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
					}
				}, 'json')
				.always(function(jqXHR) {
				    if(jqXHR.status == 404) {			    	
						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				    }
				    else if(jqXHR.status == 500) {			    	
						toastr.error('Request error. Please contact the support');

						$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
				    }
				});
			}
		}
		else {
			var data = $(form).serializeArray();
			data[data.length] = { name: 'token', value: token };

			$('.tinymce').each(function() {
				var currentEditorId = $(this).attr('id');
				var val = tinyMCE.get($(this).attr('id')).getContent();

				for (index = 0; index < data.length; ++index) {
				    if (data[index].name == currentEditorId) {
				        data[index].value = val;
				    }
				}
			});

			xhr_data(file, data);

			$('.input__field--error').removeClass('input__field--error');
			$.post(path+'Connections/request/xhr/'+file+'.php', data, function(response, statusText, jqXHR) {
				if(response.action == 'success') {
					if(response.callback === true) {
						xhr_success(file, response);
					}
					else {
						if(response.msg != null) {
							toastr.success(response.msg);						
						}
					}

					if(response.url != null) {
						location.href = response.url;
					}
				}
				else if(response.action == 'empty') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}

					$.each(response.fields, function(i, item) {
					    $(form).find('#'+item).addClass('input__field--error');
					});
				}
				else if(response.action == 'recaptcha') {
					if(response.msg != null) {
						toastr.warning(response.msg);
					}
					recaptcha();
				}
				else if(response.action == 'token') {
					location.reload();
				}
				else {
					if(response.msg != null) {
						toastr.error(response.msg);
					}

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', debug:true, token: token}, function(response2) {}, 'json');
				}
			}, 'json')
			.always(function(jqXHR) {
			    if(jqXHR.status == 404) {			    	
					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			    else if(jqXHR.status == 500) {			    	
					toastr.error('Request error. Please contact the support');

					$.post(path+'administration/request/xhr/error-log.php', { datas: data, file: file, status: jqXHR.status, method: 'post', source: 'front', token: token}, function(response2) {}, 'json');
			    }
			});
		}
	}

	// bind un click sur les éléments portant le [data-xhr]
	$(document).on('click', '[data-xhr]', function(e) {
		e.preventDefault();
		var $this = $(this);

		xhr_send(path, token, $this);
	});

	// formulaire de contact
	$(document).on('submit', '#form-contact', function(e) {	
		var data = $(this).find('input, textarea, select').filter(':visible, input[type=hidden]').serializeArray();

		$.getJSON(path+'Connections/request/xhr/contact/send-contact.php', data, function(response) {
			if(response.action == 'success') {

				toastr.success(response.msg);
				$('#alert').html('<div class="alert alert-success" role="alert">Message successfully sent !</div>');
				$('input, textarea, select').each(function(){
				    $(this).val('');
				    $('input[type=checkbox]').prop('checked', false);
				});
				
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// update des données du user
	$(document).on('submit', '#form-user-data', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-user-data.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-recovery', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/recovery.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				//location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	$(document).on('keyup', '#form-new-account input[name=password]', function() {
		var password = $('#form-new-account input[name=password]').val();
		check_pw('#form-new-account input[name=password]');			
	});

	$(document).on('keyup', '#form-update-password input[name=password], #form-update-password input[name=repassword]', function() {
		var password = $('#form-update-password input[name=password]').val();
		var repassword = $('#form-update-password input[name=repassword]').val();
		check_pw('#form-update-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
			
	});

	$(document).on('keyup', '#form-password input[name=password], #form-password input[name=repassword]', function() {
		var password = $('#form-password input[name=password]').val();
		var repassword = $('#form-password input[name=repassword]').val();
		check_pw('#form-password input[name=password]');

		if($(this).closest('form').hasClass('valid') && password == repassword) {
			$(this).closest('form').find('input[type=submit]').prop('disabled', false);
		}
		else {
			$(this).closest('form').find('input[type=submit]').prop('disabled', true);
		}
			
	});

	// recovery du mot de passe
	$(document).on('submit', '#form-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/password.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);
				location.href = response.url;
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// modification du mot de passe
	$(document).on('submit', '#form-update-password', function(e) {
		var data = $(this).serializeArray();

		$.getJSON(path+'Connections/request/xhr/membre/update-password.php', data, function(response) {
			if(response.action == 'success') {
				toastr.success(response.msg);

				$('input[type=password]').each(function(){
				    $(this).val('');
				});

				$('ul.list-styled li').removeClass('valid-regex');
			}
			else if(response.action == 'empty') {
				toastr.warning(response.msg);
			}
			else {
				toastr.error(response.msg);
			}
		});

		e.preventDefault();
		return false;
	});

	// init tooltip BS
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    // slider témoignages
    $('.slider-temoignages').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots:true,
        arrows:false,
        responsive: [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        ]
    });

    //
    $(window).scroll(function(e){  
        var scroll = $(window).scrollTop(); 
        //console.log(scroll); 

        if(scroll >= 674){
            $('.nav-inscription').removeClass('d-none');
            $('.nav-inscription').addClass('d-block');
        }else{
            $('.nav-inscription').removeClass('d-block');
            $('.nav-inscription').addClass('d-none');
        }

        
    })

    $(document).on('click', '#lesson-registration #company', function() {
    	if($(this).is(':checked')) {
			$('#lesson-registration #company_fields').removeClass('d-none');
    	}
    	else {
    		$('#lesson-registration #company_fields').addClass('d-none');
    	}
    });

    if($('#g-recaptcha-response').length > 0) {
    	
		function recaptcha()
		{
			 grecaptcha.ready(function() {
				grecaptcha.execute('6LfoEXYgAAAAAFvaOjif9bhRirfKKxvHhRsFmhUe', {action: 'send_form'})
				.then(function(token) {
					var recaptchaResponse = document.getElementById('g-recaptcha-response');
                	recaptchaResponse.value = token;
					
				})
			});
		}

    	recaptcha();
    	
		var intervalID = setInterval(recaptcha, 110*1000);
    }

    // slider témoignages
    $('.slider-cours').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots:true,
        arrows:false,
        responsive: [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        ]
    });

    // CASE INSENSITIVE FUNCTION.
	jQuery.expr[':'].contains = function(a, i, m) {
    var rExps=[
        {re: /[\xC0-\xC6]/g, ch: "A"},
        {re: /[\xE0-\xE6]/g, ch: "a"},
        {re: /[\xC8-\xCB]/g, ch: "E"},
        {re: /[\xE8-\xEB]/g, ch: "e"},
        {re: /[\xCC-\xCF]/g, ch: "I"},
        {re: /[\xEC-\xEF]/g, ch: "i"},
        {re: /[\xD2-\xD6]/g, ch: "O"},
        {re: /[\xF2-\xF6]/g, ch: "o"},
        {re: /[\xD9-\xDC]/g, ch: "U"},
        {re: /[\xF9-\xFC]/g, ch: "u"},
        {re: /[\xC7-\xE7]/g, ch: "c"},
        {re: /[\xD1]/g, ch: "N"},
        {re: /[\xF1]/g, ch: "n"}
    ];

    var element = $(a).text();
    var search  = m[3];

    $.each(rExps, function() {
         element    = element.replace(this.re, this.ch);
         search     = search.replace(this.re, this.ch);
    });

    return element.toUpperCase()
        .indexOf(search.toUpperCase()) >= 0;
    };
});

function check_pw(password) {
	var $this = $(password);
	var pw = $this.val();
	var test = true;
	// At least one LOWERCASE character:
	var lowerCasePattern = /^(?=.*[a-z]).+$/;

	if(lowerCasePattern.test(pw)) {		    
		$('.lowercase').addClass('valid-regex');
	}
	else {
		$('.lowercase').removeClass('valid-regex');
		test = false;
	}

    // At least one UPPERCASE character:
    var upperCasePattern = /^(?=.*[A-Z]).+$/;
    
    if(upperCasePattern.test(pw)) {		    
    	$('.uppercase').addClass('valid-regex');
    }
    else {
    	$('.uppercase').removeClass('valid-regex');
    	test = false;
    }

    // At least one NUMBER:
    var numberPattern = /^(?=.*[\d]).+$/;
    
    if(numberPattern.test(pw)) {		    
    	$('.number').addClass('valid-regex');
    }
    else {
    	$('.number').removeClass('valid-regex');
    	test = false;
    }

    // At least one SPECIAL character:
    var specialCharacterPattern = /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/;

    if(specialCharacterPattern.test(pw)) {		    
    	$('.specialcase').addClass('valid-regex');
    }
    else {
    	$('.specialcase').removeClass('valid-regex');
    	test = false;
    }

    // At least 8 characters in the screen:
    var characterCountPattern = /^.{8,}/;

    if(characterCountPattern.test(pw)) {		    
    	$('.minimumcase').addClass('valid-regex');
    }
    else {
    	$('.minimumcase').removeClass('valid-regex');
    	test = false;
    }

    if($('.not-secure li').length == $('.valid-regex').length) {
    	$this.closest('form').addClass('valid');
    }
    else {
    	$this.closest('form').removeClass('valid');
    }
}